<template>
	<campaigns-rule-summary-item
		v-if="groupedRules"
		:key="`rule-${index}-0`"
		:index="0"
		:group-index="index"
		:item="group.rules[0]"
		v-on="$listeners"
	>
		<template #groupPrefix>{{ 0 === index ? 'If' : 'And' }}</template>

		<template #after>
			<campaigns-rule-summary-item
				v-for="(rule, ruleIndex) in rest(groupedRules)"
				:key="`rule-${index}-${ruleIndex + 1}`"
				:index="ruleIndex + 1"
				:group-index="index"
				:group-type="groupType"
				:item="rule"
				v-on="$listeners"
			/>
		</template>
	</campaigns-rule-summary-item>
</template>

<script lang="js">

import { appData } from '@/utils'

/**
 * Campaign Rules Summary Group
 * @displayName Campaign Rules Summary Group
 * @since 2.0.0
 */
export default  {
	props : {
		/**
		 * The group items array.
		 */
		group : {
			type: Object,
			required: true,
		},
		/**
		 * Group Loop index
		 */
		index : {
			type: Number,
			default: 0,
		},
	},
	computed: {
		groupType() {
			let groupType = this.group.type
			if (!groupType) {
				groupType = 1 < this.group.rules.length ? 'or' : 'and';
			}
			return groupType;
		},
		ruleIds() {
			return this.group.rules.map(r => r.id);
		},
		rulesById() {
			const rulesById = {}

			this.group.rules.forEach(r => {
				rulesById[r.id] = r;
			})

			return rulesById;
		},
		groupedRules() {
			const grouped = appData.get('rulesetData').getGroupedRules(this.ruleIds, this.rulesById)
			const groups = Object.entries(grouped);
			const result = []

			groups.forEach(g => {
				const rules = g[1] || [];

				rules.forEach(r => {
					result.push(r);
				});
			});

			return result;
		}
	},
	methods : {
		rest (rules) {
			if (1 < rules.length) {
				// eslint-disable-next-line no-unused-vars
				let [ first, ...rest ] = rules
				return rest
			}

			return []
		},
	},
};
</script>
